/**
 * The animation seam. `reader-core` never imports an animation library; it
 * routes every visually-animatable move (page slide, zoom, programmatic scroll)
 * through a {@link ReaderTransitions} the host supplies. The default,
 * {@link instantTransitions}, applies changes synchronously — identical to the
 * pre-seam behaviour and zero cost.
 *
 * `porejs-react` ships a `gsapAdapter(gsap)` that implements this.
 */
const translate = (axis, px) => axis === 'x' ? `translateX(${px}px)` : `translateY(${px}px)`;
/** Synchronous, allocation-free. The engines' default. */
export const instantTransitions = {
    page(el, _from, to, ctx) {
        el.style.transform = translate(ctx.axis, to);
    },
    zoom(el, transform) {
        el.style.transform = transform;
    },
    scrollTo(el, prop, to) {
        el[prop] = to;
    },
    cancel() { },
};
//# sourceMappingURL=transitions.js.map